import { render, staticRenderFns } from "./diseases_common_page.vue?vue&type=template&id=14e8be26&scoped=true"
import script from "./diseases_common_page.vue?vue&type=script&lang=js"
export * from "./diseases_common_page.vue?vue&type=script&lang=js"
import style0 from "./diseases_common_page.vue?vue&type=style&index=0&id=14e8be26&lang=scss&scoped=true"
import style1 from "./diseases_common_page.vue?vue&type=style&index=1&id=14e8be26&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e8be26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e8be26')) {
      api.createRecord('14e8be26', component.options)
    } else {
      api.reload('14e8be26', component.options)
    }
    module.hot.accept("./diseases_common_page.vue?vue&type=template&id=14e8be26&scoped=true", function () {
      api.rerender('14e8be26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/diseases_common_page.vue"
export default component.exports